import { CheckCircleIcon, StarIcon, UserIcon } from '@heroicons/react/24/solid'
import { Company } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import { arrayOfObjectToStringArrayByKey } from '@/helpers/utils'
import { LocationMark } from '../atoms'
import CompanySocial from './Company/CompanySocial'
import styles from './CompanyHeaderInfo.module.scss'

interface IProps {
  company: Company
  className?: string
  headerTheme?: string | 'dark' | 'light' | undefined
  color?: string | 'grey'
  layout?: string | 'basic'
  emptyCover?: Boolean | 'true' | undefined
}

const CompanyHeaderInfo = ({
  company,
  className,
  headerTheme = 'light',
  color,
  layout,
  emptyCover = 'true',
}: IProps) => {
  const { t, lang } = useTranslation()

  return (
    <div className={`w-full bg-white ${className} ${styles.CompanyHeaderInfo}`}>
      <div
        className='flex items-stretch flex-col md:flex-row'
        style={{ borderColor: color }}
      >
        {company.logo?.url && (
          <div
            className={`${styles.CompanyHeaderInfo__logo__container} relative flex items-center bg-white`}
          >
            <div
              className={`${styles.CompanyHeaderInfo__logo__wrapper} flex justify-center`}
            >
              <img
                src={company.logo?.url}
                alt={company.name}
                className={styles.CompanyHeaderInfo__logo}
              />
            </div>
            <div
              className={`${styles.CompanyHeaderInfo__logo__divider} absolute`}
            />
            <div
              className={`${styles.CompanyHeaderInfo__logo__bg} md:hidden`}
              style={{ backgroundColor: color }}
            />
          </div>
        )}
        <div className='flex flex-col lg:flex-row w-full'>
          <div
            className={`${styles.CompanyHeaderInfo__data} md:pr-2 flex flex-col justify-between`}
          >
            <div className='flex flex-col sm:flex-row items-start justify-start'>
              <h1
                className={`${styles.CompanyHeaderInfo__companyName} text-18 font-medium md:w-auto`}
              >
                {company.name}
              </h1>
            </div>
            <div
              className={`flex flex-col sm:flex-row items-start s,:items-center ${styles.CompanyHeaderInfo__specificInfo}`}
            >
              {company.locations.length > 0 && (
                <div className={styles.CompanyHeaderInfo__location}>
                  <LocationMark
                    companyAmount={arrayOfObjectToStringArrayByKey(
                      company.locations,
                      lang === 'pl' ? 'cityPl' : 'cityEn'
                    )}
                  />
                </div>
              )}
              {company.employees && (
                <div className='text-gray-450'>
                  <UserIcon style={{ width: '16px' }} />
                  {company.employees}
                </div>
              )}
            </div>
          </div>
          {company.currentLayout !== 'basic' && (
            <div
              className={`${styles.CompanyHeaderInfo__socials} lg:ml-auto relative flex items-center`}
            >
              <CompanySocial
                company={company}
                theme={headerTheme}
                className='flex items-center'
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CompanyHeaderInfo
